import pvTrack from '../pvtrack.service';
function uuid() {
  var d = Date.now();
  if (
    typeof performance !== 'undefined' &&
    typeof performance.now === 'function'
  ) {
    d += performance.now(); //use high-precision timer if available
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (d + Math.random() * 16) % 16 | 0;
    let v = '';
    if (c === 'x') {
      v = r;
    } else {
      v = (r & 0x3) | 0x8;
    }
    return v.toString(16);
  });
}
export const nodeNames = {
  start: { nodeName: 'start', desc: '开始' },
  noServiceTime: { nodeName: 'noServiceTime', desc: '非服务时间' },
  repeatClick: { nodeName: 'repeatClick', desc: '重复点击' },
  requestToken: { nodeName: 'requestToken', desc: '请求token' },
  agoraRtc: { nodeName: 'agorartcInit', desc: '调用app声网初始化' },
  getSalesInfo: { nodeName: 'getSalesInfo', desc: '获取顾问信息' },
  channelStatusError: { nodeName: 'channelStatusError', desc: '频道状态错误' },
  timeout: { nodeName: 'timeout', desc: '呼叫超时' },
  joinRoom: { nodeName: 'joinRoom', desc: '获取到分配顾问' },
  hangUp: { nodeName: 'hangUp', desc: '挂断' },
  unknown: { nodeName: 'unknown', desc: '未知步骤' },

  salesAnswer: { nodeName: 'salesAnswer', desc: '顾问接听' },
  getIcsEncryptedStr: {
    nodeName: 'getIcsEncryptedStr',
    desc: '获取顾问加密串',
  },
  getUserInfo: { nodeName: 'getUserInfo', desc: '获取用户信息' },

  // ics专用
  stateListen: { nodeName: 'stateListen', desc: '通话中状态监听挂断' },
  processError: { nodeName: 'processError', desc: '接听中异常挂断' },
};
export const rtcTracker = {
  start(userType = 'user') {
    this.traceId = uuid();
    this.userType = userType;
    if (userType === 'user') {
      this.log(nodeNames.start);
    } else {
      this.log(nodeNames.salesAnswer);
    }
  },
  log(node, channelId = '') {
    pvTrack.pvTrackLogger({
      action: 'vr_rtc_track',
      basic: { type: 'track' },
      extend: {
        trackType: 'info',
        traceId: this.traceId,
        channelId,
        ...node,
        userType: this.userType,
      },
    });
  },
  error(node, error, channelId = '') {
    pvTrack.pvTrackLogger({
      action: 'vr_rtc_track',
      basic: { type: 'track' },
      extend: {
        trackType: 'error',
        traceId: this.traceId,
        ...node,
        error,
        message: error.message,
        detail: error.detail,
        channelId,
        userType: this.userType,
      },
    });
  },
  // 顾问挂断专用
  hangUpIcsLog(node, extend) {
    pvTrack.pvTrackLogger({
      action: 'vr_rtc_hangUpIcs',
      basic: { type: 'track' },
      extend: {
        trackType: 'hangUpIcsInfo',
        traceId: this.traceId,
        ...node,
        ...extend,
        userType: this.userType,
      },
    });
  },
};
